import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => {
  return {
    gridContainer: {
      paddingTop: '4px',
      borderBottom: '1px solid #ccc'
    },
    gridItem: {
      background: '#F2F2F2',
      paddingBottom: '1px',
      borderBottom: '0.5px solid #FFF',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    headerName: {
      flex: 0.5,
      fontWeight: 'bold',
      borderRight: '1px solid #ccc'
    }
  };
});

export default styles;
